import React, { useState } from 'react';

// Components
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import Button from '@/main/components/shared/button/button';
import { AreaButton } from '@/main/components/shared/styles';
import KogModalSideComponent from '@/main/components/modal/ModalSide';

import { BodyshopRateProvider, useBodyshopRateContext } from './bodyshopRateContext';
import BodyshopRateFilter from './bodyshopRateFilter/bodyshopRateFilter';
import BodyshopRateGrid from './bodyshopRateGrid/bodyshopRateGrid';
import BodyshopRateImportModal from './bodyshopRateImportModal/bodyshopRateImportModal';
import * as S from './styles';

function BodyshopRateManagementScreen() {
  const titlePage = `${getTranslateByKey('module.registration')} > ${getTranslateByKey('screen.bodyshopRateManagement')}`;

  const { setShowFilters } = useBodyshopRateContext();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const handleImportRedirect = () => {
    setIsImportModalOpen(true);
  };

   function handleFilters() {
    setShowFilters(prev => !prev);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return (
    <ContainerScreen title={titlePage}>
      <AreaButton>
        <Button onClick={handleFilters} id="id-bodyshopRate-btn-filters">
          {getTranslateByKey('information.filters')}
        </Button>

        <Button id="id-bodyshopRate-btn-import" onClick={handleImportRedirect}>
          {getTranslateByKey('information.import')}
        </Button>
      </AreaButton>

      <BodyshopRateFilter />
      <BodyshopRateGrid />

      <KogModalSideComponent
        open={isImportModalOpen}
        closeModal={() => setIsImportModalOpen(false)}
        id="id-bodyshopRate-modal-import"
      >
        <S.Title>{getTranslateByKey('information.import')}</S.Title>
        <BodyshopRateImportModal 
          isOpen={isImportModalOpen} 
          closeModal={() => setIsImportModalOpen(false)} 
        />
      </KogModalSideComponent>
    </ContainerScreen>
  );
}

function WrapperBodyshopRateManagementScreen() {
  return (
    <BodyshopRateProvider>
      <BodyshopRateManagementScreen />
    </BodyshopRateProvider>
  );
}

export default WrapperBodyshopRateManagementScreen;
